import { LEFT_NAV_COLLAPSED_ENABLED_CONTENT_CLASS, LEFT_NAV_EXTENDED_ENABLED_CONTENT_CLASS } from '@deltasierra/components';
import * as React from 'react';

export function useUpdateLeftNavigationBodyClasses({ isDrawerOpen }: { isDrawerOpen: boolean }) {
    React.useEffect(() => {
        const contentSection = document.getElementById('main-body-content-section');
        if (isDrawerOpen) {
            // Add extended left navigation classes to content element.
            contentSection?.classList.add(LEFT_NAV_EXTENDED_ENABLED_CONTENT_CLASS);

            // Remove collapsed left navigation class from content element.
            if (contentSection?.classList.contains(LEFT_NAV_COLLAPSED_ENABLED_CONTENT_CLASS)) {
                contentSection.classList.remove(LEFT_NAV_COLLAPSED_ENABLED_CONTENT_CLASS)
            }
        } else {
            // Add collapsed left navigation classes to content element.
            contentSection?.classList.add(LEFT_NAV_COLLAPSED_ENABLED_CONTENT_CLASS);

            // Remove extended left navigation class from content element.
            if (contentSection?.classList.contains(LEFT_NAV_EXTENDED_ENABLED_CONTENT_CLASS)) {
                contentSection.classList.remove(LEFT_NAV_EXTENDED_ENABLED_CONTENT_CLASS)
            }
        }
    }, [isDrawerOpen]);
}
